import * as utils from './utils';

const getPostingId = state => state.lead.table.params.postingId;

const getNotShowLoading = state => state.lead.table.params.notShowLoading;

const getTextSearch = state => state.lead.table.params.textSearch;

const getLeadsData = state => state.lead.table.leads;

const getLeadsDataOther = state => state.lead.table.leadsOther;
const getLeadsDataPhoneCall = state => state.lead.table.leadsPhoneCall;
const getLeadsDataWhatsapp = state => state.lead.table.leadsWhatsapp;
const getLeadsDataEmails = state => state.lead.table.leadsEmails;

const getPublisherData = state => state.lead.table.infoPublisher;

const getLeadsDataStatus = state => state.lead.table.leadStatus;

const fetchLoading = state => state.lead.table.loading;

const fetchError = state => state.lead.table.error;

const getPagingData = state => state.lead.table.paging;

const getSnackBar = state => state.lead.table.snackBar;

const getSelectedLeads = state => utils.getSelectedLeads(state.lead.table.leads);

const allSelected = state => utils.getSelectedLeads(state.lead.table.leads).length === state.lead.table.leads.length;

const isSelectedLeads = state => utils.getSelectedLeads(state.lead.table.leads).length > 0;

const allUnReadSelected = state => utils.allUnReadSelected(state.lead.table.leads);

const allReadSelected = state => utils.allReadSelected(state.lead.table.leads);

const haveUnReadSelected = state => utils.haveUnReadSelected(state.lead.table.leads);
const getTabs = state => state.lead.table.tabs;

const getEtiquetasStatus = state => state.lead.table.leadStatusError;

const getFeedbackParam = state => state.lead.table.params.feedback;

const allSelectedWithStatusNonFavorite = state => utils.allSelectedWithStatusNonFavorite(state.lead.table.leads);

const isOneSelectedWithStatusNonFavorite = state => utils.isOneSelectedWithStatusNonFavorite(state.lead.table.leads);

export {
  getNotShowLoading,
  allSelected,
  allUnReadSelected,
  allReadSelected,
  haveUnReadSelected,
  allSelectedWithStatusNonFavorite,
  isOneSelectedWithStatusNonFavorite,
  getLeadsData,
  fetchLoading,
  fetchError,
  getPagingData,
  getSnackBar,
  isSelectedLeads,
  getSelectedLeads,
  getPostingId,
  getTextSearch,
  getTabs,
  getLeadsDataStatus,
  getEtiquetasStatus,
  getPublisherData,
  getFeedbackParam,
  getLeadsDataOther,
  getLeadsDataPhoneCall,
  getLeadsDataWhatsapp,
  getLeadsDataEmails
};
